import {Component, Input, ViewEncapsulation} from '@angular/core';

type Type = 'text' | 'password' ;

@Component({
  selector: 'mat-pass-toggle-visibility',
  template: `
    <button (click)="isVisible = !isVisible"
            type="button"
            class="mat-icon-button cdk-focused cdk-mouse-focused" mat-icon-button
            matRippleCentered="true"
            matRipple>
      <mat-icon>{{isVisible ? 'visibility' : 'visibility_off' }}</mat-icon>
    </button>
  `,
  styles: [`

  `],
  encapsulation: ViewEncapsulation.None
})
export class MatPassToggleVisibilityComponent {

  @Input()
  isVisible: boolean;

  _type: Type = 'text';

  get type() {
    return this.isVisible ? 'text' : 'password';
  }

}
